export default __webpack_public_path__ + "static/schema_animation-a6ee219d5645d8a49ea704d7a659954a.webm";